/* @sravni/react-header version 0.2.43 */
/** Helper functions returns mode view config */
var getModeView = function (mode) {
    switch (mode) {
        case 'landing': {
            return {
                showLogo: true,
                showNavigate: false,
                showSearch: false,
                showUser: false
            };
        }
        case 'menuOff': {
            return {
                showLogo: true,
                showNavigate: false,
                showSearch: false,
                showUser: true
            };
        }
        default: {
            return {
                showLogo: true,
                showNavigate: true,
                showSearch: false,
                showUser: true
            };
        }
    }
};

export { getModeView };
//# sourceMappingURL=modes.js.map
